'use client'

import Spinner from '@/components/design-system/spinner'
import { useEffect, useRef } from 'react'
import './notifications-load-more.scss'

export default function NotificationsLoadMore({
  isLoadingMore,
  onLoadMore,
}: {
  isLoadingMore?: boolean
  onLoadMore?: () => void
}) {
  const ref = useRef<HTMLDivElement>(null)

  const handle = useRef(() => {})

  handle.current = () => {
    if (isLoadingMore) {
      return
    }

    onLoadMore?.()
  }

  useEffect(() => {
    const target = ref.current

    if (!target) {
      return
    }

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0]

      if (entry.isIntersecting) {
        handle.current()
      }
    })

    observer.observe(target)

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <div ref={ref} className='notifications-load-more'>
      <Spinner size='sm' />
    </div>
  )
}
